/** @format */
import React from 'react'

export default function PrivacyPolicy() {
  return (
    <>
      <h2>Privacy Policy</h2>
      <strong>1. When did we last update this Privacy Policy?</strong>
      <div>
        <br />
        January 2021
      </div>
      <br />
      <strong>2. About this Privacy Policy</strong>
      <div>
        <br />
        2.1. British American Tobacco (New Zealand) Limited (BATNZ, we, our, or
        us) respects your privacy. We are committed to safeguarding the privacy
        of our customers including, but not limited to those:
      </div>
      <br />
      <div style={{ paddingLeft: '30px' }}>
        (a) using our websites (including batnz.co.nz; vuse.co.nz;
        vusionry.co.nz as well as any applicable redirected websites);
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (b) visiting our specialist vape retail store (at 270 Broadway,
        Newmarket, Auckland); and
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (c) visiting our various offices throughout New Zealand.
      </div>
      <br />
      <div>
        2.2. In this Privacy Policy, including any future updates, (Privacy
        Policy) our customers (including visitors to our websites and physical
        premises) are referred to as you.
      </div>
      <br />
      <div>
        2.3. Please read this Privacy Policy carefully as it informs you of our
        privacy practices, including the way your information is collected, how
        that information is used and how we share, store and protect that
        information.
      </div>
      <br />
      <div>
        2.4. You agree to the collection, use and disclosure of your personal
        information under this Privacy Policy when you:
      </div>
      <br />
      <div style={{ paddingLeft: '30px' }}>(a) visit one of our websites;</div>
      <div style={{ paddingLeft: '30px' }}>
        (b) visit our speciality vape retail store;
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (c) visit one of our various offices;
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (d) access and use of our Wi-Fi;
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (e) contact us by any means (including by calling our customer response
        centre or speaking to our customer service representatives in-store); or
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (f) authorise us to collect your personal information in any other way,
        such as at promotional events.
      </div>
      <br />
      <div>
        2.5. This Privacy Policy applies to and does not restrict, our rights
        and obligations under applicable laws, including the Privacy Act 2020
        (as amended or replaced from time to time) (Privacy Act).
      </div>
      <br />
      <strong>3. How can you contact us?</strong>
      <div>
        <br />
        If you have any questions about this Privacy Policy, you can contact us
        by:
      </div>
      <br />
      <div style={{ paddingLeft: '30px' }}>
        (a) writing to us at British American Tobacco (New Zealand) Limited
      </div>
      <div style={{ paddingLeft: '30px' }}>P.O. Box 2618</div>
      <div style={{ paddingLeft: '30px' }}>Auckland 1010</div>
      <div style={{ paddingLeft: '30px' }}>
        (b) emailing us at{' '}
        <a
          href="mailto:info.nz@vuse.com"
          aria-describedby="a11y-external-message"
        >
          info.nz@vuse.com
        </a>
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (c) calling us on:{' '}
        <a href="tel:0800897369" aria-describedby="a11y-external-message">
          0800 897 369
        </a>
      </div>
      <br />
      <strong>4. What personal information do we collect?</strong>
      <div>
        <br />
        4.1. We may collect any personal information that you provide to us or
        authorise us to collect. This may include:
      </div>
      <br />
      <div style={{ paddingLeft: '30px' }}>
        (a) your name, date of birth and contact details (including home
        address, phone number and email address);
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (b) details of transactions you carry out or orders you place through
        one of our websites and information that you submit online via our
        websites;
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (c) details of your visits to our websites and the resources that you
        access (which may include, amongst other things, traffic data and
        communication data);
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (d) details of transactions you carry out or orders you place through
        our speciality vape retail store and information that you submit whilst
        shopping at our speciality vape retail store;
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (e) details that you provide to our customer response centre or our
        customer service representatives in our speciality vape retail store;
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (f) details about other people that you provide to us with their consent
        (see section 4.3); or
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (g) any other personal information that you authorise us to collect, for
        example, if you authorise us to collect your photo at a promotional
        event.
      </div>
      <br />
      <div>
        4.2. We will usually collect your personal information directly from you
        unless it is not reasonable or practical to do so. We may collect
        personal information about you from another person if we have, or they
        confirm that they have your consent.
      </div>
      <br />
      <div>
        4.3. There may be times when you provide us with personal information
        about another person, for example, in connection with promotional
        events. If you do so, you confirm that:
      </div>
      <br />
      <div style={{ paddingLeft: '30px' }}>
        (a) they are over eighteen years old;
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (b) you have their authorisation to:
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (i) provide their personal information to us; and <br />
        (ii) allow us to collect and use their information under this Privacy
        Policy.
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (c) you have or will inform them of their rights to access and request
        correction of their personal information as set out in this Privacy
        Policy.
      </div>
      <br />
      <div>
        4.4. We will not intentionally collect any information about anyone who
        is under eighteen years of age. If we become aware that anyone who is
        under eighteen years of age has provided us with any information, that
        information will immediately be deleted from our records.
      </div>
      <br />
      <div>
        4.5. When you use one of our websites, we may also collect information
        about you and your use of our websites using automatic data collection
        tools. These tools collect certain standard information about your
        access and computer, such as your browser type, operating system and
        language, access times and your Internet Protocol (IP) address. We use
        the information for statistical reporting and analytics and do not link
        it to any named individuals.
      </div>
      <br />
      <div>
        4.6. You do not have to provide us with any personal information that we
        request. However, if you do not do so, it may affect our ability to
        provide you with products or services or further information you have
        requested.
      </div>
      <br />
      <em>Payment information</em>
      <div>
        <br />
        4.7. We use Worldpay to process payments you make using one of our
        websites or in our speciality vape retail store. Worldpay operates a
        secure server to process your payment details. Worldpay encrypts your
        credit or debit card information and authorises payment directly. Any
        payment transactions will be stored on Worldpay hosting services.
      </div>
      <br />
      <div>
        4.8. This means that your credit card or debit card details are never
        revealed to us.
      </div>
      <br />
      <div>
        4.9. Please read the Worldpay privacy policy available at
        www.worldpay.com/uk/privacy-policy to see what security measures they
        have in place and how they treat your information.
      </div>
      <br />
      <em>Cookies</em>
      <div>
        <br />
        4.10. Like many online services, we use a feature called a 'cookie',
        which is a small data file that is sent to your browser from a web
        server and stored on your device's hard drive. We also use a feature
        called a ‘pixel’ , which is code that we place on our websites to
        collect data about ‘pixel events’. ‘Pixel events’ are actions that
        happen on our websites, such as adding items to your cart or signing up
        for our newsletter. References in this Privacy Policy to ‘cookies’ also
        include other means of automatically accessing or storing information on
        your device.
      </div>
      <br />
      <div>
        4.11. Cookies enable us to provide you with a better experience by
        enabling our websites to recognise that you have visited before and in
        some cases to record preferences to personalise your visit. Cookies also
        assist us to analyse the profile of our visitors and how you use our
        websites.
      </div>
      <br />
      <div>
        4.12. Sometimes we partner with third parties (such as advertising and
        social media partners) who may place a cookie (or cause a pixel event to
        trigger) on your device when you visit our websites to remember that you
        have visited our websites. This means that when you later visit another
        website, the advertisements displayed to you may be advertisements for
        our websites or products or about other products and services that are
        tailored to your apparent interests. If you click on one of our
        advertisements, it will redirect you back to one of our websites. Our
        third-party partners may provide us with information about the total
        number of views, shares, and click-throughs these advertisements have
        received. However, they will not collect or provide to us or any other
        third party any information that identifies you.
      </div>
      <br />
      <div>
        4.13. To delete or stop cookies being placed (or pixel events
        triggering) on your computer, refer to the help menu on your internet
        browser. In some cases, blocking cookies and pixels may reduce the
        functionality of our websites or otherwise prevent access to them
        depending on your chosen browser options. For further information visit
        www.aboutcookies.org.
      </div>
      <br />
      <strong>
        5. What do we do with your personal information?
        <br />
      </strong>
      <br />
      <em>Use of your personal information</em>
      <div>
        <br />
        5.1. We (and the third parties described in section 6) may use your
        personal information:
      </div>
      <br />
      <div style={{ paddingLeft: '30px' }}>
        (a) to provide you with information, products and services that you
        request;
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (b) to respond to your queries (including when you contact our customer
        care centre or speak with one of our customer service representatives in
        our speciality vape retail store);
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (c) to, if required, verify your age and identity (see sections 5.7 to
        5.11);
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (d) to facilitate our internal business operations (including for
        training and for developing, maintaining and testing our IT systems and
        infrastructure);
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (e) to ensure that our websites’ content is presented as effectively as
        possible for you;
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (f) for our internal purposes, such as quality control, website
        performance, system administration and to evaluate the use of our
        websites, so that we can provide you with enhanced services;
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (g) to notify you about changes to our websites or our services;
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (h) to provide you with information about products or services that we
        think may interest you (see section 5.4 and 5.5);
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (i) to create reports to assist with future marketing;
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (j) to carry out our obligations arising from any contracts with you,
        including providing you with the products you have ordered and for
        billing and delivery purposes;
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (k) to enable you to participate in the features of our websites, when
        you choose to do so; or
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (l) for any other purpose that you authorise or that is permitted by
        applicable law, including the Privacy Act.
      </div>
      <br />
      <em>Use of statistical and aggregated information</em>
      <div>
        <br />
        5.2. We may monitor your use of our websites and record your email
        address and/or IP address, operating system and browser type, for system
        administration and to report aggregate information. This is statistical
        information about our users’ browsing actions and patterns and does not
        identify any individual.
      </div>
      <div>
        <br />
        5.3. We may collect non-personal aggregated statistics data about
        visitors to our websites and, if applicable, sales and traffic patterns.
        Just to be clear, this information does not identify users in any
        personal capacity and we do not use this information to build profiles
        on individual users; it just contains generalised information about the
        users of our websites.
      </div>
      <br />
      <em>Marketing</em>
      <div>
        <br />
        5.4. Unless you have ‘opted-out’ and indicated that you do not want to
        hear from us if you provide us with your contact details, we may contact
        you by electronic means (including email or text message) and by
        telephone and post, with information about products and services that we
        think may be of interest to you. Please indicate with the relevant boxes
        when you create an account, or during the order process when we collect
        your information, if you do not want to receive such direct marketing
        communications. We may also pass your information to other organisations
        who may contact you to provide marketing information about their
        products and services by electronic means (including email or text
        message) and by telephone and post.
      </div>
      <br />
      <div>
        5.5. You may ask us at any time not to use your information for direct
        marketing purposes by contacting us using the details set out under the
        “How to contact us” heading below or by following the unsubscribe
        instructions contained in each electronic marketing communication.
      </div>
      <br />
      <div>
        5.6. We may also use statistical and aggregated information, as well as
        Cookies, for marketing purposes. Please refer to the information above,
        including details on how to delete or stop cookies being placed on your
        computer.
      </div>
      <br />
      <em>Verifying your age</em>
      <div>
        <br />
        5.7. If you use any of our websites or visit our speciality vape retail
        store, you will be asked to confirm that you are 18 years or over and we
        may keep a record of that confirmation.
      </div>
      <div>
        <br />
        5.8. We may take additional steps to verify that you are aged 18 years
        or over before we supply any products to you. To enable us to do this we
        will require certain information about you. This information will then
        be passed to our identity verification service provider who will check
        it against public sources of information to deliver confirmation of your
        identity and age. To verify your identity, we may also require you to
        provide:
      </div>
      <br />
      <div style={{ paddingLeft: '30px' }}>
        (a) demographic information (such as gender and birth date); and
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (b) personally identifiable information (such as your passport number or
        driving licence number) which may be used by our identity verification
        service provider to verify your details.
      </div>
      <br />
      <div>
        This information is checked against secure independent data sources to
        help verify identity.
      </div>
      <br />
      <div>
        5.9. In some cases, we may need to ask for further information to verify
        your age. If this is necessary, we will contact you to explain why.
      </div>
      <br />
      <div>
        5.10. Failing age verification will mean you cannot complete a purchase.
      </div>
      <br />
      <div>
        5.11. All information we collect from you for verifying your age will be
        used, held and disclosed by us under this Privacy Policy.
      </div>
      <br />
      <strong>6. Who do we share your information with?</strong>
      <div>
        <br />
        6.1. We may share your personal information in the following ways:
      </div>
      <br />
      <div style={{ paddingLeft: '30px' }}>
        (a) From time to time your personal information may be transferred to
        other British American Tobacco entities worldwide or to third party
        agents, representatives, business partners, sub-contractors or suppliers
        to provide us with services, such as system maintenance and support,
        storage services, customer response centre services and to assist us to
        respond to your requests (including, if required, to verify your age and
        identity).
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (b) We may also disclose your personal information to other British
        American Tobacco entities worldwide for any of the purposes set out in
        section 4 above.
      </div>
      <div style={{ paddingLeft: '30px' }}>
        (c) We may also be required to disclose your personal information to:
      </div>
      <div style={{ paddingLeft: '60px' }}>
        (i) respond to duly authorised information requests from the police and
        governmental authorities;
      </div>
      <div style={{ paddingLeft: '60px' }}>
        (ii) comply with any law, regulation, subpoena or court order;
      </div>
      <div style={{ paddingLeft: '60px' }}>
        (iii) help prevent fraud or to enforce or protect the rights and
        properties of British American Tobacco or its subsidiaries; or
      </div>
      <div style={{ paddingLeft: '60px' }}>
        (iii) help prevent fraud or to enforce or protect the rights and
      </div>
      <div style={{ paddingLeft: '60px' }}>
        (iv) protect the personal safety of British American Tobacco employees,
        third party agents or members of the public.
      </div>
      <br />
      <div>
        6.2. We may also disclose your personal information to enforce or apply
        our terms or any other agreements we have with you or to protect our
        rights, property or our customers. This may involve exchanging
        information with other companies and organisations for fraud protection
        and credit risk reduction.
      </div>
      <br />
      <div>
        6.3. Circumstances may arise where, whether for strategic or other
        business reasons, British American Tobacco decides to sell, buy, merge
        or otherwise reorganise businesses or our assets in some countries. Such
        a transaction may involve the disclosure of your personal information to
        prospective or actual purchasers, or the receipt of it from prospective
        or actual sellers. It is British American Tobacco’s practice to seek
        appropriate protection for personal information in these types of
        transactions.
      </div>
      <br />
      <div>
        6.4. We may pass your information to other organisations who may contact
        you to provide marketing information about their products and services
        by electronic means (including email or text message) and by telephone
        and post (see section 5).
      </div>
      <br />
      <div>
        6.5. We may share the non-personal aggregated statistics data about
        visitors to our websites with third parties.
      </div>
      <br />
      <div>
        6.6. The disclosure of your personal information, in accordance with
        this section, may involve the transfer of your personal information
        outside New Zealand (which may include countries that do not have
        developed data protection laws). For example, disclosure may take place
        in countries in which British American Tobacco group has business
        operations including those countries listed on our global website at
        www.bat.com/countries, in addition to India and the United States of
        America. From time to time we may need to disclose your personal
        information to parties in countries other than these. This will be on an
        ad hoc or case by case basis and for the purposes described in this
        Privacy Policy.
      </div>
      <br />
      <div>
        6.7. Any third party, agent or representative of British American
        Tobacco who imports personal information in the course of providing
        services to British American Tobacco is required to keep that
        information confidential and comply with national data protection laws
        or, where applicable, to be bound by appropriate contractual obligations
        that protect your personal information, to ensure that your personal
        information continues to be protected by security safeguards that are
        comparable to the safeguards that are required under the Privacy Act.
      </div>
      <br />
      <strong>
        7. How do we manage the accuracy of your personal information?
      </strong>
      <div>
        <br />
        7.1. We strive to keep your personal information accurately recorded.
        Generally, we will rely on you to update any personal information that
        you have provided to us.
      </div>
      <br />
      <div>
        7.2. If you would like copies of your personal information that we hold
        about you, or to request correction of any factual inaccuracies in that
        information, please contact our Privacy Officer (see section 3).
      </div>
      <br />
      <strong>
        8. How do we manage the security and storage of information we hold?
      </strong>
      <div>
        <br />
        <em>Security</em>
      </div>
      <br />
      <div>
        8.1. Any personal information that we collect in accordance with this
        Privacy Policy will be held by us at our head office, or on our behalf
        by our group companies or service providers.
      </div>
      <br />
      <div>
        8.2. We take reasonable technical and organisational security measures
        to prevent loss or unauthorised access, use, alteration or disclosure of
        personal information you provide to us or authorise us to collect. Any
        third party, agent or representative of ours who requires access to your
        information is also required to implement reasonable technical and
        organisational security measures to protect your information.
      </div>
      <br />
      <div>
        8.3. Unfortunately, the transmission of information via the Internet is
        not completely secure. Although we will apply our normal procedures and
        comply with legal requirements to protect your information, we cannot
        guarantee the security of your information transmitted to or from our
        websites and any transmission is at your own risk.
      </div>
      <div>
        <em>Links to third-party websites</em>
      </div>
      <br />
      <div>
        8.4. Our websites may, from time to time, contain links to and from
        other websites. If you follow a link to any of those sites, please note
        that those sites ought to have their own privacy policies and that we do
        not accept any responsibility or liability for those sites or their
        privacy policies. Please check those privacy policies before you submit
        your information to those sites.
      </div>
      <br />
      <div>
        <em>Login details</em>
      </div>
      <br />
      <div>
        8.5. If you have a username, password or other login details which
        enable you to access certain parts of our websites, you must not allow
        any other person to use them and must treat them as confidential. If you
        believe or suspect that someone else knows your login details you must
        contact us as soon as possible (see section 3). Please also see our
        Terms and Conditions of Sale.
      </div>
      <br />
      <strong>9. Our e-commerce websites?</strong>
      <div>
        <br />
        9.1. We use the Shopify e-commerce platform. If you order a product
        through our websites, Shopify will collect your personal information to
        provide services to us, including supporting and processing orders and
        providing aggregated data analysis. Please read the Shopify privacy
        policy available at www.shopify.com/legal/privacy to see what security
        measures Shopify has in place and how they treat your information.
      </div>
      <br />
      <div>
        9.2. We use the Klaviyo e-commerce platform. If you order a product
        through our websites, Klaviyo will collect your personal information to
        provide services to us, including supporting and processing orders and
        providing aggregated data analysis. Please read the Klaviyo privacy
        policy available at https://www.klaviyo.com/privacy to see what security
        measures Klaviyo has in place and how they treat your information.
      </div>
      <br />
      <strong>10. How (and when) we can change this Privacy Policy?</strong>
      <div>
        <br />
        10.1. We reserve the right to change this Privacy Policy at any time by
        publishing an amended Privacy Policy on this website. The updated
        version of this Privacy Policy will take effect immediately upon such
        notice and will apply to all personal information that we hold about
        you.
      </div>
      <br />
      <div style={{ paddingBottom: '30px' }}>
        10.2. You are responsible for reviewing this Privacy Policy regularly to
        ensure that you are aware of any updates. We will update you directly of
        any material changes if required by law.
      </div>
    </>
  )
}
